import { Route, Routes } from "react-router-dom";
import CurriculumBuilder from "./CurriculumBuilder";

export default function CurriculumBuilderRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CurriculumBuilder />} />
    </Routes>
  );
}
